import Mutations from '../../odata/mutations';

export default { ...new Mutations('productPrice'), ...new Mutations('productPrices') };
